// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"6306":"3b952f14f1b1939c","8394":"19cbbc7b886148dd","9331":"27a66623c49914fe"}[chunkId] + ".js";
};